module.exports = __webpack_public_path__ + "img/23.2.TN.2f0a7f36.png";